import { FC } from "react"
import AlertEnabledSettings, { DeviceTypeForm } from "../AlertEnabledSettings"
import Loader from "@/components/Loader"
import GridItem from "@/components/shared/Grid/GridItem"
import { SpinnerSize } from "@/components/shared/Spinner"
import { AlertSource } from "@/types/alert"

interface DeviceTypeProps {
   loading: boolean
   deviceType: DeviceTypeForm
   onSave: (sensorTypes: AlertSource[]) => void
}

const DeviceType: FC<DeviceTypeProps> = ({ loading, deviceType, onSave }) => {
   return (
      <GridItem size={2}>
         {loading ? (
            <div className="alert-setting-detail--loading">
               <Loader
                  size={SpinnerSize.SMALL}
                  fullHeight={false}
               />
            </div>
         ) : (
            <AlertEnabledSettings
               iconName="alerts"
               title="Device type"
               form={deviceType}
               onSave={onSave}
            />
         )}
      </GridItem>
   )
}

export default DeviceType
